import type { BehaviouralEvent as BehaviouralEventSchema } from '@skyscanner-internal/schemas-types/behavioural.pb';

export const BEHAVIOURAL_EVENT_NAMESPACE = 'Behavioural';
export const BEHAVIOURAL_EVENT_SCHEMA = 'behavioural.BehaviouralEvent';

type BehaviouralEventI = Pick<
  BehaviouralEventSchema,
  'properties' | 'numericProperties' | 'booleanProperties'
>;

type BehaviouralEventO = BehaviouralEventSchema;

export const BehaviouralEvent = (
  name: string,
  allProperties: BehaviouralEventI,
): BehaviouralEventO => ({
  name,
  ...allProperties,
});
